import React from "react";
import { BaseComponent } from "../baseComponent/BaseComponent"
import { TradeStatus } from "../../../enums/TradeStatus";
import RemoveTradeLot from "../baseComponent/RemoveTradeLot";
import { OpenAuctionWithApplications } from "./OpenAuctionWithApplications";

export class OpenAuctionWithApplicationsOrganizer extends OpenAuctionWithApplications {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>
                {this.ShortInfoLot()}
            </React.Fragment>
        )
    }
}